module.exports = __webpack_public_path__ + "static/media/norman-mccann.03784af9.jpg";